import get from 'lodash/get';

const getToggles = (state) => get(state, 'profile.toggles');

export default getToggles;
